import { format, isEqual, isWithinInterval } from 'date-fns';
import { FORMAT_DATE } from '../../../constants';
import { ESTADO } from '../../../lib/listado.enum';

const SEARCH_OPTIONS = [
  { label: 'ID', value: 'id', placeholder: 'Buscar por ID' },
  { label: 'Denunciante', value: 'name', placeholder: 'Buscar por denunciante' },
  { label: 'Correo', value: 'email', placeholder: 'Buscar por correo' },
  { label: 'Doc. identidad', value: 'document', placeholder: 'Buscar por doc. identidad' },
];

const SELECT_OPTIONS = [
  { label: 'Abierta', value: 'Abierta' },
  { label: 'En proceso', value: 'En_proceso' },
  { label: 'Pendiente', value: 'Pendiente' },
  { label: 'Finalizada', value: 'Finalizada' },
  { label: 'Desestimada', value: 'Desestimada' },
  { label: 'Enviada', value: 'Enviada' },
];

const generateFilter = ({ filter, status, date, isPendiente }) => {
  let applyFilter = {};

  if (filter) {
    applyFilter = filter.reduce((acc, { key, search }) => {
      let newFilter = {};
      const option = SEARCH_OPTIONS.find(({ label }) => label === key);
      if (option) {
        newFilter = { [option.value]: search };
      }
      return { ...acc, ...newFilter };
    }, {});
  }
  if (status) {
    applyFilter = { ...applyFilter, status: ESTADO[status.value] };
  }
  if (date) {
    applyFilter = { ...applyFilter, fechaExpedicionDesde: format(date[0], FORMAT_DATE.FILTER) };
    if (date[1] !== null) {
      applyFilter = { ...applyFilter, fechaExpedicionHasta: format(date[1], FORMAT_DATE.FILTER) };
    }
  }
  if (isPendiente) {
    applyFilter = { ...applyFilter, status: 'PENDIENTERESPUESTA' };
  }
  return applyFilter;
};

const localFilterData = ({ data, filter, idPermission }) => {
  if (!filter) {
    return data;
  }

  let dataFiltered = data;

  if (filter.id) {
    dataFiltered = dataFiltered.filter(({ complaint: { id, publicId } }) => {
      const finalId = idPermission ? String(id) : publicId;
      return finalId.includes(filter.id);
    });
  }
  if (filter.name) {
    dataFiltered = dataFiltered.filter(({ user: { name, lastname1, lastname2 } }) => {
      let fullName = 'Anónimo';
      if (name) {
        fullName = `${name} ${lastname1}${lastname2 ? ` ${lastname2}` : ''}`;
      }
      return fullName.toLowerCase().includes(filter.name.toLowerCase());
    });
  }
  if (filter.email) {
    dataFiltered = dataFiltered.filter(({ user: { email } }) => email?.toLowerCase().includes(filter.email));
  }
  if (filter.document) {
    dataFiltered = dataFiltered.filter(({ user: { document } }) => document?.toLowerCase().includes(filter.document));
  }

  if (filter.status) {
    dataFiltered = dataFiltered.filter(({ complaint: { status } }) => status === filter.status);
  }

  if (filter.isPendiente) {
    dataFiltered = dataFiltered.filter(({ complaint: { status } }) => status === filter.isPendiente);
  }

  if (filter.fechaExpedicionDesde && !filter.fechaExpedicionHasta) {
    dataFiltered = dataFiltered.filter(({ complaint: { creationDate } }) =>
      isEqual(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), new Date(filter.fechaExpedicionDesde))
    );
  }

  if (filter.fechaExpedicionHasta) {
    dataFiltered = dataFiltered.filter(({ complaint: { creationDate } }) =>
      isWithinInterval(new Date(format(new Date(creationDate), FORMAT_DATE.FILTER)), {
        start: new Date(filter.fechaExpedicionDesde),
        end: new Date(filter.fechaExpedicionHasta),
      })
    );
  }
  return dataFiltered;
};

export { SEARCH_OPTIONS, SELECT_OPTIONS, localFilterData, generateFilter };
